'use client';

import { LogoutOutlined, Tooltip } from '@wk/wk-uni-lib';

import { useTraceCommonParams } from '@/hooks/use-trace-common-params';
import { goWebSite } from '@/utils/go-web-site';
import { removeToken } from '@/utils/login';

export default function ExternalLinkIcon({
  dictionary,
  isErrorPage = false,
}: {
  dictionary: Record<string, string>;
  isErrorPage?: boolean;
}) {
  const { traceWithCommonParams } = useTraceCommonParams();

  const handleLogout = () => {
    if (!isErrorPage) {
      traceWithCommonParams({
        _event: 'C_TopNav_LogOut',
      });
    }
    removeToken();
    goWebSite();
  };

  return (
    <Tooltip title={dictionary['退出登录']}>
      <button
        onClick={handleLogout}
        className="rounded-lg border-[1px] border-border-light bg-bg-card_gray_light p-1.5">
        <LogoutOutlined className="h-6 w-6" />
      </button>
    </Tooltip>
  );
}
